// src/components/PromoProducts.jsx
import React, { useEffect, useMemo, useState } from "react";
import ProductRow from "./ProductRow";
import { listActiveProducts } from "../services/publicProductService";

export default function PromoProducts({ promo, onAdd }) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(Boolean(promo?.productIds?.length));
  const [error, setError] = useState("");

  const ids = useMemo(() => (promo?.productIds || []).filter(Boolean).map(String), [promo?.productIds]);
  const limit = useMemo(() => Math.max(1, Number(promo?.limitProducts || 10)), [promo?.limitProducts]);

  useEffect(() => {
    let aborted = false;

    (async () => {
      setError("");
      if (!ids.length) {
        setItems([]);
        setLoading(false);
        return;
      }
      try {
        setLoading(true);
        // Idéal: API supporte ids=... ; sinon on filtre côté client
        const res = await listActiveProducts({ pageSize: Math.max(60, limit), ids: ids.join(",") });
        if (aborted) return;

        const fetched = Array.isArray(res?.items) ? res.items : [];
        const byId = new Map(fetched.map(p => [String(p.id || p.slug), p]));

        const inOrder = ids.map(id => byId.get(id)).filter(Boolean).slice(0, limit);
        setItems(inOrder);
      } catch (e) {
        if (!aborted) setError(e?.message || "Impossible de charger les produits promotionnels.");
      } finally {
        if (!aborted) setLoading(false);
      }
    })();

    return () => { aborted = true; };
  }, [ids, limit]);

  if (!ids.length) return null;

  return (
    <section className="mt-3">
      <div className="d-flex justify-content-between align-items-center mb-2">
        <h6 className="m-0">
          {promo?.title ? `En promo : ${promo.title}` : "Sélection en promo"}
        </h6>
        {promo?.ctaHref && (
          promo.ctaHref.startsWith("/") ? (
            <a className="text-decoration-none small" href={promo.ctaHref}>Voir catalogue →</a>
          ) : (
            <a className="btn btn-dark" href={promo.ctaHref} target="_blank" rel="noopener noreferrer">
              Voir Catalogue →
            </a>
          )
        )}
      </div>

      {error && <div className="alert alert-warning py-2 mb-3">{error}</div>}

      {loading ? (
        <div className="row row-cols-2 row-cols-sm-3 row-cols-lg-4 row-cols-xl-5 g-3">
          {Array.from({ length: Math.min(limit, 10) }).map((_, i) => (
            <div className="col" key={`promo-skel-${i}`}>
              <div className="card h-100 shadow-sm">
                <div className="placeholder-glow">
                  <div className="card-img-top bg-light" style={{ height: "clamp(120px, 28vw, 200px)" }} />
                  <div className="card-body">
                    <span className="placeholder col-7" />
                    <div className="mt-2"><span className="placeholder col-9" /></div>
                    <div className="d-flex justify-content-between align-items-center mt-3">
                      <span className="placeholder col-4" />
                      <span className="placeholder col-3" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      ) : items.length === 0 ? (
        <div className="alert alert-light mb-0">Aucun produit à afficher pour cette promotion.</div>
      ) : (
        <ProductRow title="" items={items} onAdd={onAdd} />
      )}
    </section>
  );
}
